import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Audesp4LicitanteEstrangeiro, RegistroPrecos } from 'eddydata-lib';
import { BaseLicitacaoAudesp } from '../../util/base-licitacao-audesp';
import * as toastr from 'toastr';

declare var $: any;

@Component({
  selector: 'lib-licitacao-audesp-licitante-estrangeiro',
  templateUrl: './licitacao-audesp-licitante-estrangeiro.component.html'
})
export class LicitacaoAudespLicitanteEstrangeiroComponent extends BaseLicitacaoAudesp implements OnChanges {

  @Input() public entidade: RegistroPrecos;

  public licitanteAtual: Audesp4LicitanteEstrangeiro;
  public licitanteAnterior: Audesp4LicitanteEstrangeiro;
  public listaLotes: { id: number, nome: string }[];

  constructor(
  ) {
    super()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['entidade']) {
      this.listaLotes = [];
      if (this.entidade.tipoObjeto === 'COMPRA_SERVICO' && this.entidade.ComprasServicos?.Lote) {
        this.entidade.ComprasServicos.Lote.forEach(lote => {
          this.listaLotes.push({ id: lote.NumeroLote, nome: lote.DescricaoLote })
        })
      } else if (this.entidade.tipoObjeto === 'COMPRA_SERVICO_TI' && this.entidade.ComprasServicosTI?.Lote) {
        this.entidade.ComprasServicosTI.Lote.forEach(lote => {
          this.listaLotes.push({ id: lote.NumeroLote, nome: lote.DescricaoLote })
        })
      }
    }
  }

  public adicionar() {
    if (!this.entidade.Licitante.LicitanteEstrangeiro || this.entidade.Licitante.LicitanteEstrangeiro.length === 0) this.entidade.Licitante.LicitanteEstrangeiro = [];

    this.licitanteAtual = {
      OutroDoc: undefined, LicitanteDeclaracaoMicroEmpresaPequenoPorte: 'N', RazaoSocial: undefined,
      LicitanteAdministrador: undefined, LicitanteSocio: {}, LicitanteLoteItens: []
    }
    this.entidade.Licitante.LicitanteEstrangeiro.push(this.licitanteAtual);
    $('#dialogLicitanteEstrangeiro').modal('show');
  }

  public visualizar(item: Audesp4LicitanteEstrangeiro) {
    this.licitanteAnterior = Object.assign({}, item);
    this.licitanteAtual = item;
    this.licitanteAtual['edicao'] = true;
    $('#dialogLicitanteEstrangeiro').modal('show');
  }

  public cancelar() {
    if (this.licitanteAtual['edicao']) {
      if (this.licitanteAtual.LicitanteLoteItens.find(item => item.editavel)) {
        toastr.warning('Finalize a edição do item antes de concluir essa ação!')
        return;
      }
      let itm = this.entidade.Licitante.LicitanteEstrangeiro.find((item) => item === this.licitanteAtual);
      itm = Object.assign({}, this.licitanteAnterior);
      this.entidade.Licitante.LicitanteEstrangeiro.splice(this.entidade.Licitante.LicitanteEstrangeiro.indexOf(this.licitanteAtual), 1, itm)
    } else {
      this.remover(this.licitanteAtual);
    }
    this.licitanteAnterior = undefined;
    this.licitanteAtual = undefined;
    $('#dialogLicitanteEstrangeiro').modal('hide');
  }

  public remover(item: Audesp4LicitanteEstrangeiro) {
    this.licitanteAtual = undefined;
    this.entidade.Licitante.LicitanteEstrangeiro.splice(this.entidade.Licitante.LicitanteEstrangeiro.indexOf(item), 1)
  }

  public salvar() {
    if (this.licitanteAtual.LicitanteLoteItens.find(item => item.editavel)) {
      toastr.warning('Finalize a edição do item antes de concluir essa ação!')
      return;
    }
    if (!this.licitanteAtual?.IdentificacaoLicitante && this.entidade.modalidade === 4) {
      toastr.warning('Informe a identificação do participante antes de concluir essa ação!')
      return;
    }
    this.licitanteAtual = undefined;
    $('#dialogLicitanteEstrangeiro').modal('hide');
  }
}
